import { render, staticRenderFns } from "./PricingPersonalJewelleryPrimaryLayer.vue?vue&type=template&id=186ec743"
import script from "./PricingPersonalJewelleryPrimaryLayer.vue?vue&type=script&lang=js"
export * from "./PricingPersonalJewelleryPrimaryLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports